export class ValidationService {
  static validateEmail (value: string): boolean {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return emailRegex.test(value.toLocaleLowerCase())
  }
  static validatePhone(value: string): boolean {
    const phoneRegex = /^[0-9-+\s()]*$/
    return phoneRegex.test(value)
  }
}
